export enum DistributionListUnderValidation {
	DistributionList = 'DistributionList',
}
